import React, { Component, createContext } from "react";
import { firestore } from "../firebase";
import Helper from "../components/helper";

export const PLANITEM_APP_CONTEXT = createContext();

class PlanItemAPPProvider extends Component {
  state = { app_planItems: undefined };

  unsubscribe = null;

  subscribeToBranch = () => {
    this.unsubscribe = firestore.collection(Helper.getBranchCollectionName("containers", this.props.branchCode))
    .where("state", "==", "a")
    .onSnapshot(snapshot => {
      const containerObjs = snapshot.docs.map(doc => {
        return { id: doc.id, routingContainerState: "a", ...doc.data()};
      });

      let notInvoicedList = containerObjs.filter(function (obj) {
        return obj.invoiced !== true;
      });

      notInvoicedList.sort((a, b) => Helper.compareDateLike(a.apptDate, b.apptDate));

      this.setState({ app_planItems : notInvoicedList });
    });
  };

  componentDidMount = () => {
    this.subscribeToBranch();
  };

  componentDidUpdate = prevProps => {
    if ((prevProps.branchCode || "NY") !== (this.props.branchCode || "NY")) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.setState({ app_planItems: undefined }, this.subscribeToBranch);
    }
  };

  componentWillUnmount = () => {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  };

  render() {
    const { app_planItems } = this.state;
    const { children } = this.props;

    return <PLANITEM_APP_CONTEXT.Provider value={app_planItems}>{children}</PLANITEM_APP_CONTEXT.Provider>;
  }
}

export default PlanItemAPPProvider;

PlanItemAPPProvider.defaultProps = {
  branchCode: "NY",
};
